// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

body{
  font-family: 'Poppins', 'Montserrat', sans-serif !important;
  font-style: normal;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}


/* dashboard graph css */
svg text {
  font-size: 16px !important;
  font-weight: 600 !important;
  transform: rotate(-45deg, 80, 330) !important;
}`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;;AAGA,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;AAC/C","sourcesContent":["body {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nbody{\n  font-family: 'Poppins', 'Montserrat', sans-serif !important;\n  font-style: normal;\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n\n/* dashboard graph css */\nsvg text {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  transform: rotate(-45deg, 80, 330) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
